import { CompensationMethod } from "@redotech/redo-return-core-common/compensation-method";
import { BrightpearlCancelSalesCreditOn } from "@redotech/redo-return-core-common/integrations/returns/brightpearl/brightpearl";
import { createEnum } from "@redotech/zod-util/zod-enum";
import {
  array,
  boolean,
  number,
  object,
  string,
  type infer as zInfer,
} from "zod";

export const brightpearlSalesCreditCustomFieldSchema = object({
  fieldKey: string().min(1, "Field name is required"),
  fieldValue: string().min(1, "Field value is required"),
});

export type BrightpearlSalesCreditCustomFieldInput = zInfer<
  typeof brightpearlSalesCreditCustomFieldSchema
>;

// Brightpearl caps paymentMethodCode at 36 characters.
export const brightpearlPaymentMethodCodeSchema = object({
  compensationMethod: createEnum(CompensationMethod),
  paymentMethodCode: string().min(1).max(36),
});

export type BrightpearlPaymentMethodCodeInput = zInfer<
  typeof brightpearlPaymentMethodCodeSchema
>;

// BP status ids are positive integers. We don't enumerate them — merchants
// look them up in their BP back office (Settings → Order types → Statuses).
const brightpearlStatusIdSchema = number().int().nonnegative();

export const updateBrightpearlReturnsSettings = {
  name: "updateBrightpearlReturnsSettings" as const,
  input: object({
    enabled: boolean().optional(),
    customFieldsOnSalesCredit: array(
      brightpearlSalesCreditCustomFieldSchema,
    ).optional(),
    markSalesCreditAsPaid: boolean().optional(),
    paymentMethodCodes: array(brightpearlPaymentMethodCodeSchema).optional(),
    processableStatusIds: array(brightpearlStatusIdSchema).optional(),
    flaggableStatusIds: array(brightpearlStatusIdSchema).optional(),
    // `null` clears the status label.
    cancelledStatusId: brightpearlStatusIdSchema.nullish(),
    cancelSalesCreditOn: createEnum(BrightpearlCancelSalesCreditOn).optional(),
  }),
  output: object({ success: boolean() }),
};
